import { refundMethodExtraLabels, refundMethodsWithExtra } from '@/returns/constants'

import { availableRefundTypes } from './constants'

export const shouldShowRefundMethodExtra = (refundType, refundMethod, extraAmount) => {
  return (
    refundType === availableRefundTypes.refund &&
    refundMethodsWithExtra.includes(refundMethod) &&
    Number(extraAmount) > 0
  )
}

export const getRefundMethodExtraLabel = (refundMethod, t) => {
  const extraLabel = refundMethodExtraLabels[refundMethod]

  if (!extraLabel) return ''

  return t(extraLabel)
}
